import { addSchemaField } from '../utils';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  card_bg: {
    id: 'Colore di sfondo della card',
    defaultMessage: 'Colore di sfondo della card',
  },
  primary: {
    id: 'primary',
    defaultMessage: 'Primario',
  },
  secondary: {
    id: 'secondary',
    defaultMessage: 'Secondario',
  },
  tertiary: {
    id: 'tertiary',
    defaultMessage: 'Terziario',
  },
  white: {
    id: 'white',
    defaultMessage: 'Bianco',
  },
});

const getLinkCardVariationSchema = (schema, formData, intl, pos = 0) => {
  addSchemaField(
    schema,
    'card_background_color',
    intl.formatMessage(messages.card_bg),
    null,
    {
      widget: 'color_list',
      colors: [
        {
          name: 'primary',
          label: intl.formatMessage(messages.primary),
        },
        {
          name: 'secondary',
          label: intl.formatMessage(messages.secondary),
        },
        {
          name: 'tertiary',
          label: intl.formatMessage(messages.tertiary),
        },
        {
          name: 'white',
          label: intl.formatMessage(messages.white),
        },
      ],
      defaultValue: 'white',
    },
    pos,
  );
  pos++;
};

export default getLinkCardVariationSchema;
